<template>
    <div class="dashboard-nav">
        <div class="dropdown-nav-item"
            v-for="phase in this.phases"
            :key="phase.Id"
        >
            <div class="dropdown" v-if="phase.HasFrameworkConditions">
                <button
                    class="btn btn-phase dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    :id="getIdForDropdown(phase.Name)"
                >
                    <div v-if="useIcon" class="icon-phase mx-1">
                        <img
                            :src="getSrcIcon(phase.Name)"
                            height="15"
                            width="15"
                        />
                    </div>
                    <span class="title-phase">{{ phase.Name }}</span>
                </button>
                <div
                    class="dropdown-menu"
                    :aria-labelledby="getIdForDropdown(phase.Name)"
                >
                    <router-link
                        :to="
                            '/result/phase/' + replaceSpaceAndMakeLowerCase(phase.Name)
                        "
                    >
                        <a class="dropdown-item">Phase</a>
                    </router-link>
                    <router-link
                        :to="
                            '/result/phase/' +
                                replaceSpaceAndMakeLowerCase(phase.Name) +
                                '-framework-condition'
                        "
                    >
                        <a class="dropdown-item" href="#">Rahmenbedingungen</a>
                    </router-link>
                </div>
            </div>
            <button v-else class="btn btn-phase" type="button">
                <router-link
                    :to="'/result/phase/' + replaceSpaceAndMakeLowerCase(phase.Name)"
                >
                <div class="d-flex flex-row">
                    <div v-if="useIcon" class="icon-phase mx-1">
                        <img
                            :src="getSrcIcon(phase.Name)"
                            height="20"
                            width="20"
                        />
                    </div>
                    <span class="title-phase">{{ phase.Name }}</span>
                </div>
                    
                </router-link>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "VerticalNav",
    props: ["phases", "useIcon"],
    computed: {},
    methods: {
        replaceSpaceAndMakeLowerCase(name) {
            return name.replaceAll('-', '').replace(/\s/g, '-').toLowerCase();
        },
        getIdForDropdown(name) {
            return "dropdown-" + this.replaceSpaceAndMakeLowerCase(name);
        },
        getSrcIcon(name) {
            return (
                "/images/dropdown/" +
                name.replaceAll('-', '').replace(/\s/g, '-').toLowerCase() +
                ".svg"
            );
        }
    }
};
</script>

<style scoped>
.page-item{
    display: flex;
    align-items: center;
}
</style>

